import { Icon } from '@/shared/components'
import { pxToRem } from '@/shared/styles/themes'
import { Accordion, AccordionDetails, AccordionSummary, CircularProgress, styled, Typography } from '@mui/material'

export const StyledSectionHeader = styled('div')`
  position: sticky;
  top: 0;
  z-index: 1;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`

export const StyledHeaderTitle = styled('div')`
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  padding-left: ${({ theme }) => theme.typography.pxToRem(4)};
`

export const StyledTreeContainer = styled('div')`
  position: relative;
  background-color: ${({ theme }) => theme.palette.background.paper};
`

export const StyledSectionTypography = styled(Typography)`
  font-weight: 500;
  font-size: ${({ theme }) => theme.typography.pxToRem(14)};
  padding: 0 ${({ theme }) => theme.typography.pxToRem(8)};
  z-index: 4;
`

export const StyledTreeHeader = styled('div')`
  position: sticky;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  z-index: 2;
  height: ${pxToRem(32)};
  background-color: ${({ theme }) => theme.palette.background.default};
`

export const StyledTreeHeaderActions = styled('div')`
  display: inline-flex;
`

export const StyledHeaderIcon = styled(Icon)`
  font-size: ${pxToRem(16)};
`

export const StyledAccordion = styled(Accordion)`
  background-color: transparent;
  border-radius: 0 !important;
  box-shadow: none;
  margin: 0;

  &.Mui-expanded {
    margin: 0;
  }
  
  &.MuiPaper-root::before {
    opacity: 1 !important;
  }
`

export const StyledAccordionSummary = styled(AccordionSummary)`
  padding: 0;
  background-color: ${({ theme }) => theme.palette.background.paper};

  &.MuiAccordionSummary-root {
    position: sticky;
    min-height: ${({ theme }) => theme.typography.pxToRem(32)} !important;
    top: ${pxToRem(32)};
    z-index: 1;
  }

  & .MuiAccordionSummary-content {
    margin: 0 !important;
  }

  &.Mui-expanded {
    min-height: ${({ theme }) => theme.typography.pxToRem(32)} !important;
    
    & .MuiSvgIcon-cheveron {
      transform: rotate(90deg);
    }
  }
`

export const StyledAccordionDetails = styled(AccordionDetails)`
  padding-left: 0;
  padding-right: 0;
  padding-top: 0;
  padding-bottom: 0;
`


export const StyledActionIcon = styled(Icon)`
  font-size: ${props => props.theme.typography.pxToRem(16)};
  width: ${props => props.theme.typography.pxToRem(16)};
  height: ${props => props.theme.typography.pxToRem(16)};
  transform: none !important;
`

export const StyledTreeItemIcon = styled(Icon)`
  font-size: ${props => props.theme.typography.pxToRem(14)};
  width: ${props => props.theme.typography.pxToRem(14)};
  height: ${props => props.theme.typography.pxToRem(14)};
`

export const StyledLoadingContainer = styled('div')`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  position: sticky;
  bottom: 0;
  width: 100%;
`

export const StyledLoadingIndicator = styled(CircularProgress)`
  margin-right: 12px;
  margin-bottom: 12px;
`